export default __webpack_public_path__ + "static/media/score card.b6130fd6.svg";